






import {Component} from 'vue-property-decorator'
import Posts from '@/components/admin/Posts.vue'
import PageBase, {BreadCrumb} from '@/pages/page-base'

@Component({
  components: {
    Posts
  }
})
export default class NewJobsIndex extends PageBase {
  mounted(): void {
    super.mounted()
  }

  get breadcrumbs(): Array<BreadCrumb> {
    return [
      {
        text: '新着求人一覧'
      }
    ]
  }
}
